<div class="marv_tag"
    [class.is_clickable]="this.isClickable"
    [class.disabled]="this.disabledTag"
    [class.big]="this.sizeTag === 'big'"
    [class.small]="this.sizeTag === 'small'"
    [class.secondary]="this.colorTag === 'secondary'"
    [class.blue]="this.colorTag === 'blue'"
    [class.red]="this.colorTag === 'red'"
    [class.green]="this.colorTag === 'green'"
    [class.orange]="this.colorTag === 'orange'"
    [class.purple]="this.colorTag === 'purple'"    
    [class.marvesting]="this.colorTag === 'marvesting'" 
    (click)="this.clickTag($event)"
    >
    @if(this.iconTag !== ''){
         <ion-icon class="marv_tag_icon" [name]="this.iconTag"></ion-icon>
    }
    <div class="marv_tag_content">
        <ng-content></ng-content>
    </div>
    @if(this.showCloseButton){
        <ion-icon class="marv_tag_close" name="close-circle-outline" (click)="this.closeTag($event)"></ion-icon>
    }    
</div>